export const PAGE_TITLE =
  'TNO Media Lab | Propuesta Sortilegio — Posicionamiento de Marca';
export const PAGE_DESCRIPTION =
  'Propuesta estratégica TNO Media Lab para Distribuidora de Quesos Sortilegio: posicionamiento de marca, autoridad comercial y expansión de mercado en Gran Caracas. Planes desde $350 USD/mes.';

export const TNO_MEDIA_LAB_LOGO = '/images/tno-media-lab/logo.svg?v=2';
export const TNO_MEDIA_LAB_LOGO_BG = '#FFFFFF';

export const hero = {
  brand: 'TNO Media Lab',
  overline: 'Propuesta estratégica · V3',
  client: 'Distribuidora de Quesos Sortilegio',
  city: 'Caracas, Venezuela',
  title: 'Posicionamiento de marca, autoridad comercial y expansión de mercado',
  subtitle:
    'Construir y consolidar a Sortilegio como la marca referente de quesos artesanales y lácteos de alta calidad en la Gran Caracas, con publicidad digital, gestión de redes, canal B2B y captación de equipo comercial.',
  highlights: ['B2C + B2B', 'Gran Caracas', 'Marca, no commodity'],
  cta: 'Ver planes de inversión',
  snapshot: {
    badge: 'TNO Media Lab · Agencia',
    items: [
      { label: 'Cliente', value: 'Sortilegio' },
      { label: 'Territorio', value: 'Gran Caracas' },
      { label: 'Horizonte', value: '90 días +' },
      { label: 'Inversión', value: 'Desde $350/mes' },
      { label: 'Enfoque', value: 'B2C + B2B' },
      { label: 'Canales', value: 'Redes, WhatsApp, Meta' },
    ],
  },
};

export const diagnostico = {
  overline: '01 · Diagnóstico',
  title: 'Posicionamiento y oportunidad de mercado',
  intro:
    'En el mercado gastronómico y de consumo masivo de Caracas, la percepción de calidad está ligada a tres pilares: autenticidad de origen, frescura constante y confiabilidad en la distribución.',
  pillars: [
    {
      id: 'origen',
      icon: 'explore',
      title: 'Sabor de pueblo / llano',
      text: 'Autenticidad de origen. El queso no se vende solo por kilo: se elige por historia, territorio y carácter artesanal.',
    },
    {
      id: 'frescura',
      icon: 'verified',
      title: 'Frescura constante',
      text: 'La preferencia se gana cuando el producto llega igual de vivo al bodegón, a la pizzería y a la mesa del hogar.',
    },
    {
      id: 'distribucion',
      icon: 'speed',
      title: 'Distribución confiable',
      text: 'El aliado comercial elige a quien no falla. Disponibilidad, consistencia y servicio son estatus de marca.',
    },
  ],
  opportunity:
    'Hoy hay múltiples distribuidores no diferenciados que compiten únicamente por precio. La oportunidad de Sortilegio es trascender el commodity (queso por kilo) y convertirse en una marca de confianza, estatus y preferencia — para el consumidor final y para aliados estratégicos: bodegones, pizzerías, restaurantes y supermercados.',
};

export const pilarDigital = {
  overline: '02 · Pilar I',
  title: 'Gestión digital, branding y posicionamiento en redes',
  subtitle:
    'La presencia digital constante y bien estructurada moldea la percepción de marca y genera deseo de consumo (snack appeal) con material visual propio o adaptado.',
  items: [
    {
      icon: 'design',
      title: 'Contenido y branding digital',
      text: 'Curaduría, diseño y publicación orientados a la experiencia sensorial: frescura, origen artesanal y usos del queso en la gastronomía local.',
    },
    {
      icon: 'devices',
      title: 'Formatos educativos y de antojo',
      text: 'Piezas gráficas y reels conectados con la cultura caraqueña: la arepa perfecta con queso Guayanés, o la tabla ideal para el fin de semana en Caracas.',
    },
    {
      icon: 'stars',
      title: 'Micro-influencers gastronómicos',
      text: 'Kits de Experiencia Sortilegio para chefs, gastronómicos y creadores de estilo de vida en Caracas: validación social y recomendación orgánica.',
    },
  ],
};

export const pilarPublicidad = {
  overline: '03 · Pilar II',
  title: 'Estrategia publicitaria multicanal en Caracas',
  subtitle: 'B2C para reconocimiento y pedidos. B2B para abrir y fidelizar cuentas. BTL para asociar Sortilegio a marcas y rituales de prestigio.',
  channels: [
    {
      canal: 'Meta Ads geolocalizado (B2C)',
      enfoque:
        'Posicionar la marca en zonas clave de Caracas (Chacao, Las Mercedes, El Hatillo, Baruta y más) asociada a frescura, calidad y conveniencia.',
      impacto: 'Reconocimiento local y tráfico cualificado hacia WhatsApp Business para pedidos directos.',
    },
    {
      canal: 'Posicionamiento B2B',
      enfoque:
        'Presentar a Sortilegio no solo como proveedor, sino como socio estratégico de chefs, compradores y dueños de locales.',
      impacto: 'Catálogos institucionales, kits de degustación y fidelización de cuentas clave.',
    },
    {
      canal: 'Activaciones BTL y co-branding',
      enfoque:
        'Alianzas con embutidos, panaderías artesanales o eventos gastronómicos: Combo Parrillero, Combo Desayuno Criollo.',
      impacto: 'Asociación con aliados de prestigio y penetración acelerada en nuevos nichos.',
    },
  ],
};

export const metaAds = {
  overline: '04 · Meta Ads',
  title: 'Qué son, por qué importan y cómo los gestionamos',
  subtitle:
    'Meta Ads es el motor de visibilidad pagada de esta propuesta: Facebook e Instagram, geolocalizados en Caracas, con destino a WhatsApp Business y a captación comercial.',
  what: {
    title: 'Qué son Meta Ads',
    text:
      'Meta Ads es la plataforma de publicidad pagada de Meta: anuncios en Facebook, Instagram, Messenger y Audience Network. Permite mostrar piezas de Sortilegio a personas y negocios concretos —por zona, intereses, comportamiento y lookalike— en el momento en que están abiertas a descubrir, pedir o comprar queso artesanal.',
  },
  why: [
    {
      icon: 'public',
      title: 'Alcance local con precisión',
      text: 'Llegamos a Chacao, Las Mercedes, El Hatillo, Baruta y otras zonas de la Gran Caracas sin desperdiciar presupuesto en audiencias fuera del radio de distribución.',
    },
    {
      icon: 'speed',
      title: 'De antojo a pedido',
      text: 'El contenido orgánico construye marca; la pauta acelera el resultado. El anuncio lleva al WhatsApp Business para pedidos directos y a validación de aliados B2B.',
    },
    {
      icon: 'dashboard',
      title: 'Medición y ajuste semanal',
      text: 'Cada dólar deja rastro: alcance, clics, conversaciones y costo por resultado. Eso permite escalar lo que funciona y cortar lo que no, con evidencia.',
    },
  ],
  howTitle: 'Cómo lo vamos a gestionar',
  howIntro:
    'TNO Media Lab opera la estrategia, las piezas y la optimización. El cliente conserva el control del gasto en pauta, para total transparencia.',
  how: [
    {
      owner: 'TNO Media Lab',
      title: 'Estrategia y operación',
      items: [
        'Estructura de campañas B2C (reconocimiento y conversión a WhatsApp) y, en el Plan Expansión, reclutamiento comercial.',
        'Definición de audiencias geolocalizadas, intereses gastronómicos y exclusiones.',
        'Creatividades alineadas al tono de marca: frescura, origen artesanal y snack appeal.',
        'Optimización continua de presupuesto, copys y pujas según resultados.',
        'Reporte periódico de desempeño y recomendaciones de escalamiento.',
      ],
    },
    {
      owner: 'Sortilegio',
      title: 'Inversión y transparencia',
      items: [
        'La pauta se paga directo a Meta desde la cuenta del cliente: ustedes ven cada cargo.',
        'Presupuesto recomendado a partir de $100 USD/mes para cobertura en las zonas objetivo.',
        'Acceso al Business Manager y a los resultados en tiempo real.',
        'Aprobación de mensajes, ofertas y destinos (WhatsApp, catálogo, reclutamiento).',
      ],
    },
  ],
};

export const pilarEmbajadores = {
  overline: '05 · Pilar III',
  title: 'Embajadores de marca: reclutamiento y cultura comercial',
  subtitle:
    'La fuerza de ventas es la cara visible de Sortilegio ante los comercios de Caracas. Captamos perfiles que transmitan profesionalismo y los valores de la marca.',
  items: [
    {
      icon: 'launch',
      title: 'Campaña de reclutamiento con prestigio',
      text: 'Anuncios dirigidos a profesionales comerciales: “Representa a la marca de quesos de mayor proyección y crecimiento en Caracas”.',
    },
    {
      icon: 'team',
      title: 'Perfil del vendedor / embajador',
      text: 'Ejecutivos B2B con experiencia en consumo masivo (FMCG) y relaciones activas con restaurantes, bodegones y cadenas.',
    },
    {
      icon: 'assignment',
      title: 'Herramientas de presentación',
      text: 'Carpetas comerciales digitales, fichas de producto, precios competitivos y esquema de comisiones por fidelización de cuentas.',
    },
    {
      icon: 'voice',
      title: 'Cultura y capacitación',
      text: 'Inducción en historia, origen artesanal y atributos diferenciadores para una argumentación de venta uniforme y profesional.',
    },
  ],
};

export const fases = {
  overline: '06 · Roadmap',
  title: 'Fases de evolución de marca',
  subtitle: 'Un trimestre para pasar de identidad a liderazgo local. Luego, escalamiento continuo.',
  steps: [
    {
      phase: 'Mes 1',
      icon: 'design',
      title: 'Identidad y lanzamiento',
      subtitle:
        'Tono de marca, optimización de redes, catálogo comercial y canales de atención directa (WhatsApp Business).',
    },
    {
      phase: 'Mes 2',
      icon: 'launch',
      title: 'Penetración y presencia',
      subtitle:
        'Campañas de captación de vendedores y despliegue de kits B2B para aliados gastronómicos.',
    },
    {
      phase: 'Mes 3+',
      icon: 'stars',
      title: 'Liderazgo y consolidación',
      subtitle:
        'Escalamiento de pauta, co-branding, activaciones en puntos de venta y consolidación de la red de distribución.',
    },
  ],
};

export const inversion = {
  overline: '07 · Inversión',
  title: 'Esquema de inversión mensual',
  subtitle: 'Honorarios de TNO Media Lab. La pauta en Meta Ads la gestiona el cliente, con total transparencia.',
  plans: [
    {
      id: 'foco',
      name: 'Plan Foco Local',
      price: '$350',
      period: 'USD / mes',
      recommended: false,
      includes: [
        'Gestión integral de redes sociales',
        'Catálogo comercial digital',
        'Configuración y optimización de WhatsApp Business',
        'Campañas continuas de posicionamiento B2C en Meta Ads',
      ],
    },
    {
      id: 'expansion',
      name: 'Plan Expansión de Marca',
      price: '$650',
      period: 'USD / mes',
      recommended: true,
      includes: [
        'Todo lo del Plan Foco Local',
        'Estrategia B2B integral',
        'Campañas de reclutamiento comercial',
        'Coordinación de activaciones de marca',
      ],
    },
  ],
  adsNote:
    'La inversión en pauta publicitaria (Meta Ads) es gestionada directamente por el cliente. Se recomienda un presupuesto base a partir de $100 USD/mes para cobertura en las zonas objetivo.',
};

export const cierre = {
  overline: 'Siguiente paso',
  title: 'Sortilegio deja de vender queso por kilo. Empieza a ocupar un lugar en Caracas.',
  subtitle:
    'TNO Media Lab opera la estrategia. Ustedes concentran producto, distribución y relación con el mercado. Conversemos el plan con el que quieren arrancar.',
  cta: 'Conversar esta propuesta',
  whatsappMessage:
    'Hola, vengo de la propuesta TNO Media Lab para Distribuidora de Quesos Sortilegio. Quiero avanzar con el plan.',
  footer: '© TNO Media Lab 2026 · Propuesta confidencial V3 · Sortilegio × TNO Media Lab',
};
